import { useState, useCallback } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

const VIDEO_ID = "Exu7r2vZpcw";
const THUMB_URL = `https://img.youtube.com/vi/${VIDEO_ID}/hqdefault.jpg`;

const VideoSection = () => {
  const [loaded, setLoaded] = useState(false);

  const handlePlay = useCallback(() => setLoaded(true), []);

  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="font-heading text-3xl md:text-5xl font-bold text-foreground mb-4"
        >
          See It In Action
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="font-body text-muted-foreground text-lg mb-10 max-w-lg mx-auto"
        >
          Watch what it's like to step into virtual reality with our Meta Quest 3 rentals.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="relative w-full rounded-2xl overflow-hidden border border-border shadow-2xl cursor-pointer"
          style={{ aspectRatio: "16/9" }}
          onClick={!loaded ? handlePlay : undefined}
          role={!loaded ? "button" : undefined}
          aria-label={!loaded ? "Play VR rental demo video" : undefined}
          tabIndex={!loaded ? 0 : undefined}
          onKeyDown={!loaded ? (e) => { if (e.key === "Enter" || e.key === " ") handlePlay(); } : undefined}
        >
          {loaded ? (
            <iframe
              width="100%"
              height="100%"
              src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1&si=h19DP59ST8_4gR8I`}
              title="VR Rental Experience - Meta Quest 3 Demo"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className="absolute inset-0 w-full h-full"
            />
          ) : (
            <>
              <img
                src={THUMB_URL}
                alt="VR Rental Experience - Meta Quest 3 Demo thumbnail"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 flex items-center justify-center bg-background/30">
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-primary/90 flex items-center justify-center shadow-lg glow-magenta">
                  <Play className="w-8 h-8 md:w-10 md:h-10 text-primary-foreground ml-1" />
                </div>
              </div>
            </>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default VideoSection;
